module.exports = __webpack_public_path__ + "img/jdm1.25824859.jpg";